import API, { apiErrorMessage } from "../global/api";
import { listPaging } from "../global/Utils";

// Add Item
export const addItemRequest = () => {
  return {
    type: "ADD_ITEM_REQUEST",
  };
};
export const addItemSuccess = (data) => {
  return {
    type: "ADD_ITEM_SUCCESS",
    payload: data,
  };
};
export const addItemError = (msg) => {
  return {
    type: "ADD_ITEM_ERROR",
    payload: msg,
  };
};
export const addItem = (
  data,
  setFormData,
  handleVisible,
  handleDangerVisible,
) => {
  return (dispatch) => {
    dispatch(addItemRequest());
    API.post(`/item/add-item`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(addItemSuccess(data1));
        handleVisible(data1.message);
        setFormData({
          name: "",
          serial: "",
          unitPrice: 0,
          uom: "",
          extraTax: 0,
          furtherTax: 0,
          fedPayable: 0,
          saleTaxSource: 0,
          retailPrice: 0,
          HSCodeId: "",
          companyId: "",
          HSCodeName: "",
          userId: "",
          // The next item starts as a service product too (AddItem.jsx).
          itemType: "SERVICE_PRODUCT",
          openingQuantity: "",
          stockUnit: "",
          lowStockThreshold: "",
        });
      })
      .catch((error) => {
        dispatch(addItemError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Getting Items List
export const getItemRequest = () => {
  return {
    type: "ITEM_LIST_REQUEST",
  };
};
export const getItemSuccess = (data) => {
  return {
    type: "ITEM_LIST_SUCCESS",
    payload: data,
  };
};
export const getItemError = (msg) => {
  return {
    type: "ITEM_LIST_ERROR",
    payload: msg,
  };
};
// Only the newest list request may fill the list: typing in a search sends one
// request per pause, and an older answer arriving late must not replace the
// newer one.
let latestItemListRequest = 0;

/**
 * `filters` is the Item List's Company search, optional:
 *   companyId    one company, picked from the suggestions
 *   companyName  any part of a company name, as typed
 */
export const getItem = (page, limit, searchTerm, filters = {}) => {
  return (dispatch) => {
    const requestNo = ++latestItemListRequest;
    dispatch(getItemRequest());
    const paging = listPaging(page, limit);
    const companyId = filters.companyId
      ? `&companyId=${encodeURIComponent(filters.companyId)}`
      : "";
    const companyName = String(filters.companyName ?? "").trim()
      ? `&companyName=${encodeURIComponent(filters.companyName)}`
      : "";
    API.get(
      `/item/get-items?page=${paging.page}&limit=${paging.limit}&search=${searchTerm}${companyId}${companyName}`,
    )
      .then((res) => {
        if (requestNo !== latestItemListRequest) return;
        let itemsList = res.data;
        dispatch(getItemSuccess(itemsList));
      })
      .catch((error) => {
        if (requestNo !== latestItemListRequest) return;
        dispatch(getItemError(apiErrorMessage(error)));
      });
  };
};

// Updating Items
export const updateItemRequest = () => {
  return {
    type: "UPDATE_ITEM_LIST_REQUEST",
  };
};
export const updateItemSuccess = (data) => {
  return {
    type: "UPDATE_ITEM_LIST_SUCCESS",
    payload: data,
  };
};
export const updateItemError = (msg) => {
  return {
    type: "UPDATE_ITEM_LIST_ERROR",
    payload: msg,
  };
};
export const updateItem = (
  id,
  data,
  handleVisible,
  handleDangerVisible,
  navigate,
) => {
  return (dispatch) => {
    dispatch(updateItemRequest());
    API.put(`/item/update-item/${id}`, data)
      .then((res) => {
        let updateItemList = res.data;
        dispatch(updateItemSuccess(updateItemList));
        handleVisible(res.data.message, () => navigate("/main/view-item-list"));
      })
      .catch((error) => {
        dispatch(updateItemError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Deleting Items
export const deleteItemRequest = () => {
  return {
    type: "DELETE_ITEM_LIST_REQUEST",
  };
};
export const deleteItemSuccess = (data) => {
  return {
    type: "DELETE_ITEM_LIST_SUCCESS",
    payload: data,
  };
};
export const deleteItemError = (msg) => {
  return {
    type: "DELETE_ITEM_LIST_ERROR",
    payload: msg,
  };
};
export const deleteItem = (
  id,
  handleVisible,
  handleDangerVisible,
  page,
  limit,
  searchTerm,
  filters,
) => {
  return (dispatch) => {
    dispatch(deleteItemRequest());
    API.delete(`/item/delete-item/${id}`)
      .then((res) => {
        let deleteItemList = res.data;
        dispatch(deleteItemSuccess(deleteItemList));
        handleVisible(res.data.message);
        dispatch(getItem(page, limit, searchTerm, filters));
      })
      .catch((error) => {
        dispatch(deleteItemError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Getting Uom
export const getUomRequest = () => {
  return {
    type: "UOM_LIST_REQUEST",
  };
};
export const getUomSuccess = (data) => {
  return {
    type: "UOM_LIST_SUCCESS",
    payload: data,
  };
};
export const getUomError = (msg) => {
  return {
    type: "UOM_LIST_ERROR",
    payload: msg,
  };
};
export const getUom = () => {
  return (dispatch) => {
    dispatch(getUomRequest());
    API.get(`/uom/get-uoms`)
      .then((res) => {
        let uomList = res.data;
        dispatch(getUomSuccess(uomList));
      })
      .catch((error) => {
        dispatch(getUomError(apiErrorMessage(error)));
      });
  };
};
